.wrapper {
  --form-field-input-width: 80px;

  justify-content: space-between;
  align-items: center;
  padding: 0 calc(var(--spacer) * 2.5);
  height: auto;

  .load-more {
    margin-right: calc(var(--spacer) * 1.5);
  }

  .load-more-footer {
    display: flex;
    align-items: center;
    flex: 1;
    padding-left: calc(2 * var(--spacer));
  }

  &.is-loading {
    .load-items-count {
      display: none;
    }
  }

  .grid-refresh {
    display: flex;
    align-items: center;
  }

  .back-to-top {
    padding-right: calc(var(--spacer) * 2.5);
    margin-right: calc(var(--spacer) * 2.5);
    line-height: 12px;
    border-right: 1px solid var(--chart-100-pressed);
  }

  .load-more-wrapper {
    flex-wrap: nowrap;
    flex: 1;
  }

  .load-items-count {
    width: auto;
  }
}

:host {
  display: flex;
}

:host([hideGridRefresh]) {
  .wrapper {
    .grid-refresh {
      display: none;
    }
  }
}

:host([hasPagination]) {
  .load-more,
  .back-to-top,
  .load-more-wrapper {
    display: none;
  }
}

:host(:not([hasPagination])) {
  .wrapper {
    .pagination-footer {
      display: none;
    }
  }
}
